export default __webpack_public_path__ + "static/media/gif.5fc3d261.gif";